export default __webpack_public_path__ + "static/media/lydia_logo.667377b5.svg";